"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templates = require("./templates");
Object.keys(_templates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _templates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _templates[key];
    }
  });
});